export const MIN_TIME = 0;
export const MAX_TIME = 24 * 60 - 1;


export function invalidValue(value) {
    return new Error('Value ' + JSON.stringify(value) + ' of type ' + typeof (value) + ' is not accepted');
}


export function valueDateValidator(value) {
    if (Array.isArray(value))
        return validateVectorDateValue(value);

    return validateScalarDateValue(value);
}


export function validateScalarDateValue(value) {
    if (value == null || (value instanceof Date) || typeof (value) === 'number')
        return true;

    throw invalidValue(value);
}


export function validateVectorDateValue(value) {
    if (value == null)
        return true;

    if (!Array.isArray(value))
        throw invalidValue(value);

    for (const it of value) {
        validateScalarDateValue(it);
    }

    return true;
}


export function validateTimeValue(value) {
    if (value == null)
        return true;

    if (Array.isArray(value))
        return validateVectorTimeValue(value);

    return validateScalarTimeValue(value);
}


export function validateScalarTimeValue(value) {
    if (typeof (value) !== 'number')
        throw invalidValue(value);

    if (value < MIN_TIME)
        throw new Error('Value ' + value + ' is less than ' + MIN_TIME);

    if (value > MAX_TIME)
        throw new Error('Value ' + value + ' is greater than ' + MAX_TIME);

    return true;
}


export function validateVectorTimeValue(value) {
    if (!Array.isArray(value))
        throw invalidValue(value);

    for (const it of value) {
        validateScalarTimeValue(it);
    }

    return true;
}
